(function($) {
	$.fn.junoQuickBuy = function() {
		$('.juno-quick-add .size-option label').click(function(e) {
			e.preventDefault();
			$(this).next().slideToggle();
		});

		$('.juno-quick-add .product-option-size li').click(function(e) {
			e.preventDefault();
			variantSize = $(this).data('size');
			variantId = $(this).data('variantid');
			$(this).addClass('active').parent().slideToggle().prev().data('variantid', variantId).text(variantSize).removeClass('error').next().find('li').not(this).removeClass('active');
		});

		$('.juno-quick-add .product-add .btn').click(function(e) {
			thisButton = $(this);
			thisVariant = thisButton.prev().find('label');
			variantId = thisVariant.data('variantid');
			selectOptionDefault = thisVariant.data('text');

			if(variantId == '') {
				thisButton.prev().find('label').addClass('error');
			} else {
				thisButton.prev().find('label').removeClass('error');
				var jsonData = '';
				$('body').trigger('added.ProductScreen-' + variantId);
				$.post('/cart/add.js', { quantity: 1, id: variantId }, null, 'json').done(function(data) {
					if (data.product_title) {
						$('<span class="btn message success">已加入購物車</span>').insertAfter(thisButton.parent());
						thisButton.parents('.juno-quick-add').eq(0).addClass('added hide-quick-add').delay(3600).queue(function(next){
							$(this).removeClass('added').delay(600).queue(function(next){
								$(this).removeClass('hide-quick-add').find('.message').remove();
								thisVariant.data('variantid','').text(selectOptionDefault);
								next();
							});
							next();
						});

						$('body').trigger('added.ajaxProduct');
						document.dispatchEvent(new CustomEvent('added:ajaxProduct', {
							detail: {
								product: data
							}
						}));
						//$('.js-drawer-open-cart').eq(0).click();
						//$('body').trigger('added.ajaxProduct');
						theme.cart._updateCart();
					}
				}).fail(function(data) {
					if (data.responseJSON.description) {
						jsonData = data;
						thisButton.parents('.juno-quick-add').eq(0).addClass('added hide-quick-add').delay(3600).queue(function(next){
							$(this).removeClass('added').delay(600).queue(function(next){
								$(this).removeClass('hide-quick-add').find('.message').remove();
								thisVariant.data('variantid','').text(selectOptionDefault);
								next();
							});
							next();
						});
					}
				});
			}
		});
	}
}(jQuery));
